<template>
  <div>
    <!-- <el-table :data="userRecords">
      <el-table-column label="时间">
        <template slot-scope="scope">
          <span>{{scope.row.createdTime | moment}}</span>
        </template>
        </el-table-column>
        <el-table-column
          label="类型">
          <template slot-scope="scope">
            <span v-if="scope.row.txType==(1)">
              {{'充值'+scope.row.txCoin}}
            </span>
            <span v-if="scope.row.txType==(-1)">
              {{'提现'+scope.row.txCoin}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="(充值/提现)金额"
          prop="txAmount">
        </el-table-column>
        <el-table-column
          label="提现手续费"
          prop="txFee">
        </el-table-column>
        <el-table-column
          label="从"
          prop="txFromWallet">
        </el-table-column>
        <el-table-column
          label="至"
          prop="txToWallet">
        </el-table-column>
        <el-table-column
          label="hash">
          <template slot-scope="scope">
            <span v-if="scope.row.txHash">
              <a :href="scope.row.txHash" target="_blank">{{scope.row.txHash}}</a>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="__status"
          label="状态">
        </el-table-column>
      </el-table>
      <div class="user-withdrawal-pager-wrap">
        <pagination
          :size="pagination.size"
          :page="pagination.page"
          :total="userDetailTotal"
          @pageChanged="handleCurrentChange"
          >
        </pagination>
      </div> -->
    <div class="action">
      <div>
        <span>用户ID：{{ uid }}</span>
        <span>账号：{{ emails }}</span>
       
      </div>
      <div>
        <a  @click="getExcel" target="_blank" >导出Excel</a>
      <el-checkbox v-model="hideZero" style="margin-left: 20px;">隐藏余额为0的币种</el-checkbox>
      </div>
    </div>
    <balance :hideZero="hideZero"></balance>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Pagination from 'components/pagination';
import Balance from '../balance';

export default {
  name: 'records',
  props: ['uid', 'emails'],
  data() {
    return {
      hideZero: false,
      pagination: {
        page: 1,
        size: 10
      }
    };
  },
  computed: {
    ...mapState('withdrawalAudit', [
      'userRecords',
      'userDetailTotal',
      'userWallet'
    ])
  },
  components: {
    Pagination,
    Balance
  },
  methods: {
    ...mapActions('withdrawalAudit', [
      'getUserRecords',
      'resetUserRecords',
      'getUserWallet','exportExcel'
    ]),
    getList() {
      this.getUserRecords({
        userId: this.uid,
        ...this.pagination
      });
    },
    handleCurrentChange(pagination) {
      this.pagination = pagination;
      this.getList();
    },
    getExcel(){
      this.exportExcel({
            endTime: this.value2?this.value2[1].valueOf():'',
            startTime: this.value2?this.value2[0].valueOf():'',
            userId:this.uid
        }).then(res=>{
        const link=document.createElement('a') 
      const blob = new Blob([res], { type: 'application/vnd.ms-excel' }) //设置文件流
      link.style.display = 'none'
      // 设置连接
      link.href = URL.createObjectURL(blob)  //将文件流转化为blob地址
      console.log('link-href',link.href);
      link.download = '账户余额报表'
      document.body.appendChild(link)
      // 模拟点击事件
      link.click()  //设置点击事件

      });
    }
  },
  mounted() {
    // this.getList();
    // alert(this.emails)
    this.getUserWallet({ userId: this.uid });
  },
  destroyed() {
    this.resetUserRecords();
  }
};
</script>
<style lang="less" scoped>
.action {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 20px;
  span {
    margin-right: 20px;
  }
}
</style>
